import Button from './Button';

export default function ServiceCard({ imageSrc, imageAlt, title, description, buttonText = "Scopri di Più", buttonHref, showButton = true }) {
  // Solo queste 4 immagini principali hanno la variante "-sm.webp" fisicamente presente sul server.
  const hasMobileImage = [
    '/occhiali-da-vista-ottica-bellodi-torino.webp',
    '/occhiali-da-sole-ottica-bellodi-torino.webp',
    '/lenti-a-contatto-ottica-bellodi-torino.webp',
    '/montature-lenti-su-misura-ottica-bellodi-torino.webp'
  ].includes(imageSrc);

  return (
    <div className="group flex flex-col rounded-2xl bg-white overflow-hidden card-inner-border h-full">
      <div className="overflow-hidden relative">
        <img
          src={imageSrc}
          srcSet={hasMobileImage ? `${imageSrc.replace('.webp', '-sm.webp')} 480w, ${imageSrc} 900w` : undefined}
          sizes={hasMobileImage ? "(max-width: 640px) 480px, 900px" : undefined}
          alt={imageAlt}
          width="900"
          height="609"
          className="w-full h-64 object-cover transition-transform duration-700 ease-out group-hover:scale-110"
          loading="lazy"
        />
        {/* Sottile ombra interna per fondere l'immagine */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" />
      </div>
      <div className="p-8 flex flex-col flex-grow">
        <h3 className="font-serif text-2xl text-primary mb-4 group-hover:text-accent-dark transition-colors duration-300">{title}</h3>
        <p className="text-base text-taupe mb-8 flex-grow">
          {description}
        </p>
        <div className="mt-auto">
          {showButton && (
            <Button variant="secondary" href={buttonHref}>
              {buttonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
